"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _star = _interopRequireDefault(require("./star"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var StarRatings = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(StarRatings, _React$Component);

  var _super = _createSuper(StarRatings);

  function StarRatings() {
    var _this;

    (0, _classCallCheck2.default)(this, StarRatings);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      highestStarHovered: -Infinity
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fillId", "starGrad".concat(Math.random().toFixed(15).slice(2)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hoverOverStar", function (starRating) {
      return function () {
        _this.setState({
          highestStarHovered: starRating
        });
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "unHoverOverStar", function () {
      _this.setState({
        highestStarHovered: -Infinity
      });
    });
    return _this;
  }

  (0, _createClass2.default)(StarRatings, [{
    key: "stopColorStyle",
    value: function stopColorStyle(color) {
      var stopColorStyle = {
        stopColor: color,
        stopOpacity: "1"
      };
      return this.props.ignoreInlineStyles ? {} : stopColorStyle;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          starRatedColor = _this$props.starRatedColor,
          starEmptyColor = _this$props.starEmptyColor;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "star-ratings",
        title: this.titleText,
        style: this.starRatingsStyle
      }, /*#__PURE__*/_react.default.createElement("svg", {
        className: "star-grad",
        style: this.starGradientStyle
      }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
        id: this.fillId,
        x1: "0%",
        y1: "0%",
        x2: "100%",
        y2: "0%"
      }, /*#__PURE__*/_react.default.createElement("stop", {
        offset: "0%",
        className: "stop-color-first",
        style: this.stopColorStyle(starRatedColor)
      }), /*#__PURE__*/_react.default.createElement("stop", {
        offset: this.offsetValue,
        className: "stop-color-first",
        style: this.stopColorStyle(starRatedColor)
      }), /*#__PURE__*/_react.default.createElement("stop", {
        offset: this.offsetValue,
        className: "stop-color-final",
        style: this.stopColorStyle(starEmptyColor)
      }), /*#__PURE__*/_react.default.createElement("stop", {
        offset: "100%",
        className: "stop-color-final",
        style: this.stopColorStyle(starEmptyColor)
      })))), /*#__PURE__*/_react.default.createElement("div", {
        role: "radiogroup",
        "aria-describedby": this.props["aria-describedby"],
        id: this.props.id,
        "aria-labelledby": "".concat(this.props.id, "-label"),
        className: "prmbl-stars"
      }, this.renderStars));
    }
  }, {
    key: "starRatingsStyle",
    get: function get() {
      var starRatingsStyle = {
        position: "relative",
        boxSizing: "border-box",
        display: "inline-block"
      };
      return this.props.ignoreInlineStyles ? {} : starRatingsStyle;
    }
  }, {
    key: "starGradientStyle",
    get: function get() {
      var starGradientStyle = {
        position: "absolute",
        zIndex: "0",
        width: "0",
        height: "0",
        visibility: "hidden"
      };
      return this.props.ignoreInlineStyles ? {} : starGradientStyle;
    }
  }, {
    key: "titleText",
    get: function get() {
      var _this$props2 = this.props,
          typeOfWidget = _this$props2.typeOfWidget,
          selectedRating = _this$props2.rating;
      var hoveredRating = this.state.highestStarHovered;
      var currentRating = hoveredRating > 0 ? hoveredRating : selectedRating; // fix it at 2 decimal places and remove trailing 0s

      var formattedRating = parseFloat(currentRating.toFixed(2)).toString();

      if (Number.isInteger(currentRating)) {
        formattedRating = String(currentRating);
      }

      var starText = "".concat(typeOfWidget, "s");

      if (formattedRating === "1") {
        starText = typeOfWidget;
      }

      return "".concat(formattedRating, " ").concat(starText);
    }
  }, {
    key: "offsetValue",
    get: function get() {
      var rating = this.props.rating;
      var ratingIsInteger = Number.isInteger(rating);
      var offsetValue = "0%";

      if (!ratingIsInteger) {
        var firstTwoDecimals = rating.toFixed(2).split(".")[1].slice(0, 2);
        offsetValue = "".concat(firstTwoDecimals, "%");
      }

      return offsetValue;
    }
  }, {
    key: "renderStars",
    get: function get() {
      var _this2 = this;

      var _this$props3 = this.props,
          changeRating = _this$props3.changeRating,
          selectedRating = _this$props3.rating,
          numberOfStars = _this$props3.numberOfStars,
          starDimension = _this$props3.starDimension,
          starSpacing = _this$props3.starSpacing,
          starRatedColor = _this$props3.starRatedColor,
          starEmptyColor = _this$props3.starEmptyColor,
          starHoverColor = _this$props3.starHoverColor,
          gradientPathName = _this$props3.gradientPathName,
          ignoreInlineStyles = _this$props3.ignoreInlineStyles,
          svgIconPath = _this$props3.svgIconPath,
          svgIconViewBox = _this$props3.svgIconViewBox,
          name = _this$props3.name;
      var highestStarHovered = this.state.highestStarHovered;
      var numberOfStarsArray = Array.apply(null, Array(numberOfStars)); // eslint-disable-line prefer-spread

      return numberOfStarsArray.map(function (_, index) {
        var starRating = index + 1;
        var isStarred = starRating <= selectedRating; // hovered only matters when changeRating is true

        var hoverMode = highestStarHovered > 0;
        var isHovered = starRating <= highestStarHovered;
        var isCurrentHoveredStar = starRating === highestStarHovered; // only matters when changeRating is false
        // given star 5 and rating 4.2:  5 > 4.2 && 4 < 4.2;

        var isPartiallyFullStar = starRating > selectedRating && starRating - 1 < selectedRating;
        var isFirstStar = starRating === 1;
        var isLastStar = starRating === numberOfStars;
        return /*#__PURE__*/_react.default.createElement(_star.default, {
          key: starRating,
          starNumber: starRating,
          numberOfStars: numberOfStars,
          "data-testid": "starWrapper",
          fillId: _this2.fillId,
          disabled: _this2.props.disabled,
          changeRating: changeRating ? function () {
            return changeRating(starRating, name);
          } : null,
          hoverOverStar: changeRating ? _this2.hoverOverStar(starRating) : null,
          unHoverOverStar: changeRating ? _this2.unHoverOverStar : null,
          isStarred: isStarred,
          "aria-checked": selectedRating === index + 1,
          isPartiallyFullStar: isPartiallyFullStar,
          isHovered: isHovered,
          hoverMode: hoverMode,
          isCurrentHoveredStar: isCurrentHoveredStar,
          isFirstStar: isFirstStar,
          isLastStar: isLastStar,
          starDimension: starDimension,
          starSpacing: starSpacing,
          starHoverColor: starHoverColor,
          starRatedColor: starRatedColor,
          starEmptyColor: starEmptyColor,
          gradientPathName: gradientPathName,
          ignoreInlineStyles: ignoreInlineStyles,
          svgIconPath: svgIconPath,
          svgIconViewBox: svgIconViewBox,
          role: "radio"
        });
      });
    }
  }]);
  return StarRatings;
}(_react.default.Component);

StarRatings.propTypes = {
  rating: _propTypes.default.number.isRequired,
  numberOfStars: _propTypes.default.number.isRequired,
  changeRating: _propTypes.default.func,
  starHoverColor: _propTypes.default.string.isRequired,
  starRatedColor: _propTypes.default.string.isRequired,
  starEmptyColor: _propTypes.default.string.isRequired,
  starDimension: _propTypes.default.string.isRequired,
  starSpacing: _propTypes.default.string.isRequired,
  gradientPathName: _propTypes.default.string.isRequired,
  ignoreInlineStyles: _propTypes.default.bool.isRequired,
  svgIconPath: _propTypes.default.string.isRequired,
  svgIconViewBox: _propTypes.default.string.isRequired,
  name: _propTypes.default.string,
  typeOfWidget: _propTypes.default.string,
  "aria-describedby": _propTypes.default.string,
  id: _propTypes.default.string,
  disabled: _propTypes.default.bool
};
StarRatings.defaultProps = {
  rating: 0,
  typeOfWidget: "Star",
  numberOfStars: 5,
  changeRating: null,
  starHoverColor: "rgb(230, 67, 47)",
  starRatedColor: "rgb(109, 122, 130)",
  starEmptyColor: "rgb(203, 211, 227)",
  starDimension: "50px",
  starSpacing: "7px",
  gradientPathName: "",
  ignoreInlineStyles: false,
  svgIconPath: "m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z",
  svgIconViewBox: "0 0 51 48"
};
var _default = StarRatings;
exports.default = _default;